import React from 'react';

import clsx from 'clsx';

import * as classes from './Variable.module.css';

const Variable = ({
    innerEditor,
    parentId,
    id,
    sensorTypes,
    ...props
}) => {

    return (
        <span style={{ display: 'flex', alignItems: 'center' }} id={`variable_${id}`}>
            <React.Fragment>&nbsp;</React.Fragment>
            <div
                data-allow-insert={false}
                data-parentId={parentId}
                data-id={id}
                id={`variable_${id}`}
                className={classes.VariableBlock}
            >
                <div data-allow-insert={false} className={classes.VariableContainer}>
                    <div data-allow-insert={false} className={classes.AttributeContainer}>
                        { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label data-allow-insert={false} className={classes.Label}>Sensor Type</label>
                        { /* eslint-disable-next-line jsx-a11y/no-onchange */}
                        <select data-allow-insert={false} data-id={id} className={classes.Select}>
                            {
                                sensorTypes.map(item => {
                                    return (
                                        <option data-itemid={item.id}>{item.name}</option>
                                    );
                                })
                            }
                        </select>
                    </div>
                    <div data-allow-insert={false}>
                        { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                        <label data-allow-insert={false} className={classes.Label}>Aggregate</label>
                        <select data-allow-insert={false} autoComplete="true" className={classes.SelectAggregate}>
                            <option value="Attribute A">Average</option>
                            <option value="Attribute B">Count</option>
                            <option value="Attribute C">First</option>
                            <option value="Attribute D">Last</option>
                            <option value="Attribute E">Max</option>
                            <option value="Attribute F">Min</option>
                            <option value="Attribute G">Sum</option>
                            <option value="Attribute H">Delta</option>
                        </select>
                        <input
                            data-allow-insert={false}
                            className={classes.Input}
                            type="text"
                            id="fname"
                            value="30"
                            name="fname"
                        />
                    </div>
                </div>
                <span
                    data-allow-insert={false}
                    id={`${id}-delete`}
                    role="none"
                    class={clsx('material-icons-outlined', classes.DeleteIcon)}
                >
                    delete
                </span>
            </div>
            <React.Fragment>&nbsp;</React.Fragment>
        </span>
    );
};

export default Variable;
